module.exports = __webpack_public_path__ + "img/Avion_en_papier.84cecd9.svg";